export const NAME = "organizationDetailView"
export const FORM_NAME = "OrganizationForm"
export const DELETE_FORM_NAME = "DeleteOrganizationForm"
